<script lang="ts">
  import { tick } from 'svelte';
  import NewsletterSubscriptionFullWidth from './NewsletterSubscriptionFullWidth.svelte';
  import NewsletterSubscriptionInline from './NewsletterSubscriptionInline.svelte';
  import { browser } from '$app/environment';
  import { analytics } from '$lib/gateway/segment';

  export let newsletterSubscriptionProps: {
    title: string;
    description: string;
    width: boolean;
  };
  let isSubmitted = false;
  let errorMessage = '';
  let checkboxError = false;

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  function resetFormValidation() {
    isSubmitted = false;
    errorMessage = '';
    checkboxError = false;
  }

  async function handleSubmit(e) {
    resetFormValidation();
    await tick();
    const email = e.target[0].value;
    const checkbox = e.target[1].checked;

    // Email Validation
    if (!email || !emailRegex.test(email)) {
      errorMessage = 'Please enter a valid email';
    }

    // Checkbox Validation
    if (!checkbox) {
      checkboxError = true;
    }

    if (errorMessage || checkboxError) return;
    isSubmitted = true;

    if (browser) {
      analytics.track('Newsletter Subscribed', {
        email,
        signup_source: 'sweat.com',
        account: 'sweat',
        locale: 'en',
      });
    }
  }
</script>

{#if newsletterSubscriptionProps?.width}
  <NewsletterSubscriptionFullWidth
    {...newsletterSubscriptionProps}
    {isSubmitted}
    {errorMessage}
    {checkboxError}
    {handleSubmit}
  />
{:else}
  <NewsletterSubscriptionInline
    {...newsletterSubscriptionProps}
    {isSubmitted}
    {errorMessage}
    {checkboxError}
    {handleSubmit}
  />
{/if}
